import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import { faTrashCan } from '@fortawesome/pro-duotone-svg-icons'

import FaIcon from '../shared/faIcon/FaIcon'

// ----------------------------------------------------------------------

export const chipProps = { size: 'small', variant: 'soft' }

export function FiltersResult({ t, sx, onClearAll, children, ...other }) {
  return (
    <ResultRoot sx={sx} {...other}>
      <ResultContent>
        {children}

        <Button
          color='error'
          onClick={onClearAll}
          startIcon={<FaIcon icon={faTrashCan} />}
        >
          {t('common.clear-all')}
        </Button>
      </ResultContent>
    </ResultRoot>
  )
}

// ----------------------------------------------------------------------

const ResultRoot = styled('div')``

const ResultContent = styled('div')(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(1)
}))
